/* RU — эталонный язык. ui.* задаёт канонический набор ключей (UIKey).
   data пустой: для RU источник правды — config.ts (см. tField). */
export const ru = {
  ui: {
    'html.rotate': 'Поверни устройство<br>горизонтально',

    // HUD
    'hud.level': 'УР. {n}',
    'hud.gold': '{gem} {n}',
    'hud.eternalNight': '{spark} ВЕЧНАЯ НОЧЬ',
    'hud.lightPower': '{bolt} УРОН ×1.6 · {s}с',
    'hud.boss': 'БОСС',
    'hud.coreLabel': 'ЯДРО',
    'hud.heatLabel': 'жар · свет {n}%',
    'hud.poleLo': 'ЯРОСТЬ +{n}%',
    'hud.poleHi': 'ЗАРЯ +{n}%',

    // Баннеры (game.ts)
    'banner.cache': 'ТАЙНИК — золото и вспышка света',
    'banner.font': 'ИСТОЧНИК — лечение и сила урона',
    'banner.relic': 'РЕЛИКВИЯ — {name}',
    'banner.bossDown': '{name} ПОВЕРЖЕН',
    'banner.darkFork': 'РАЗВИЛКА ТЬМЫ',
    'banner.eliteWave': 'ПРОРЫВ ТЕНЕЙ',
    'banner.heattide': 'ПРИЛИВ ЖАРА',
    'banner.anomaly': 'ТЬМА: {name}',
    'banner.evolution': 'ЭВОЛЮЦИЯ — {name}',
    'banner.synergy': 'СИНЕРГИЯ — {name}',
    'banner.forge': 'КОВКА — {name}',
    'banner.overclock': 'ПЕРЕГРЕВ — {name}',
    'banner.enrage': '{name} — ЯРОСТЬ',
    'banner.snare': 'ТЕНЁТА — ДЕРЖИ ЗОНУ!',
    'banner.snareWin': 'ОЧАГ РАЗОЖЖЁН!',
    'banner.snareDefend': 'ОЧАГ — ЗАЩИЩАЙ!',
    'banner.snareDefendWin': 'ОЧАГ ВЫСТОЯЛ!',
    'banner.snareFail': 'ОЧАГ ПОГАС!',
    'banner.snareWaveCleared': 'ВОЛНА ОТБИТА',
    'hud.snareWave': 'волна {n}/{total}',
    'hud.snareNextWave': 'след. волна',
    'banner.revive': 'ВТОРОЕ ДЫХАНИЕ',
    'banner.dawn': '{spark} Р А С С В Е Т {spark}',

    // Меню
    'menu.tagline': 'Расти или остывай.',
    'menu.subtitle': 'S U R V I V O R S',
    'menu.start': '{play} ИГРАТЬ',
    'menu.shop': '{gem} МАГАЗИН',
    'menu.moveKeyboard': 'WASD / стрелки — движение      оружие стреляет само',
    'menu.moveTouch': 'тащи палец — движение      оружие стреляет само',
    'menu.hintCollect': 'собирай искры → новый уровень → выбирай улучшение',
    'menu.hintDawn': 'доживи до Рассвета (10:00) → дальше вечная ночь. иди к {spark} свету вдали',
    'menu.best': 'лучший забег: {time}',
    'menu.depthStat': 'глубина: {n}/{total}',
    'menu.codexStat': 'кодекс: {n}/{total}',
    'menu.settings': '{gear} НАСТРОЙКИ',

    // Выбор героя / глубины
    'charselect.title': 'ВЫБОР ИСКРЫ',
    'charselect.controls': '← →  выбрать   ·   Enter / клик — в бой',
    'charselect.locked': '???',
    'charselect.lockedFallback': 'заперт',
    'charselect.surface': 'Поверхность',
    'charselect.depthTitle': 'ГЛУБИНА ТЬМЫ   ( ↑ ↓  или клик ◂ ▸ )',
    'charselect.pathTitle': 'ПУТЬ   ( Q E  или клик ◂ ▸ )',
    'charselect.depthReward': '{desc}   ·   награда ×{mult}',
    'charselect.depthLocked': 'доживи до Рассвета (10:00) — откроется Глубина Тьмы (больше угроз и наград)',

    // Магазин
    'shop.title': 'МАГАЗИН СВЕТА',
    'shop.back': '← НАЗАД',
    'shop.controls': '↑ ↓  выбрать   ·   Enter / клик — купить   ·   Esc / M — назад',
    'shop.max': 'МАКС',
    'shop.trackForge': 'КУЗНИЦА',
    'shop.trackHearth': 'ГОРНИЛО',

    // Драфт (левелап / событие / святилище)
    'draft.shrineTitle': '{spark} СВЯТИЛИЩЕ {spark}',
    'draft.eventTitle': 'РАЗВИЛКА ТЬМЫ',
    'draft.anomalyTitle': '{moon} ЗАВЕТ ТЬМЫ {moon}',
    'draft.levelTitle': 'УРОВЕНЬ {n}',
    'draft.shrineHint': 'выбери реликвию  ·  навсегда до конца забега  ·  1 / 2 / 3',
    'draft.eventHint': 'выбери путь  ·  без правильного ответа  ·  1 / 2 / 3',
    'draft.anomalyHint': 'выбери, какой будет эта ночь  ·  назад пути нет  ·  ещё {n}',
    'draft.levelHint': 'выбери улучшение  ·  1 / 2 / 3  или  клик',
    'draft.reroll': '{cycle} пересобрать  ·  R  ·  раз за забег',
    'draft.snareTitle': 'ТЕНЁТА — ДЕРЖИ ЗОНУ',
    'draft.snareHint': 'выбери опору  ·  держись в зоне — розжиг растёт  ·  1 / 2 / 3',
    'draft.snareDefendTitle': 'ОЧАГ — ЗАЩИЩАЙ',
    'draft.snareDefendHint': 'выбери опору  ·  защити ядро от роя  ·  1 / 2 / 3',
    'draft.new': 'НОВОЕ',
    'draft.lvlChange': 'Ур. {a} → {b}',

    // Тип карты в драфте
    'kind.event': 'РАЗВИЛКА',
    'kind.evolve': '{star} ЭВОЛЮЦИЯ {star}',
    'kind.anomaly': '{moon} ЗАВЕТ ТЬМЫ',
    'kind.relic': '{spark} РЕЛИКВИЯ',
    'kind.weapon': 'ОРУЖИЕ',
    'kind.passive': 'ПАССИВ',
    'kind.bonus': 'БОНУС',
    'kind.boon': 'ОПОРА',
    'kind.forge': 'КОВКА',
    'kind.overclock': 'ПЕРЕГРЕВ',
    'forge.ocName': 'Перегрев: {w}',
    'forge.ocDesc': 'Сверх предела ур.5 — мощь ценой света. +{dmg}% урона · −{cost} света · стак {n}/{max}',

    // Карта лечения (когда реликвии кончились)
    'heal.name': 'Лечение',
    'heal.desc': 'Восстановить 25% HP',

    // Пауза
    'pause.title': 'ПАУЗА',
    'pause.stats': 'Ур. {lvl}   ·   {time}   ·   {skull} {kills}   ·   свет {light}',
    'pause.weapons': 'ОРУЖИЕ',
    'pause.passives': 'ПАССИВЫ',
    'pause.relics': 'РЕЛИКВИИ',
    'pause.synergies': 'СИНЕРГИИ',
    'pause.victory': '{spark} УЙТИ С РАССВЕТОМ — ПОБЕДА (V)',
    'pause.resume': '{play} ПРОДОЛЖИТЬ (ESC)',
    'pause.quit': 'В МЕНЮ (Q)',
    'pause.settings': '{gear} НАСТРОЙКИ',

    'settings.title': 'НАСТРОЙКИ',
    'settings.back': '← НАЗАД',
    'settings.volume': 'ГРОМКОСТЬ',
    'settings.crt': 'РЕТРО CRT ЭФФЕКТ',
    'settings.language': 'ЯЗЫК',
    'settings.on': 'ВКЛ',
    'settings.off': 'ВЫКЛ',

    // Итоги
    'results.dead': 'ТЫ ПАЛ',
    'results.finale': 'ДНО ТЬМЫ ПОКОРЕНО',
    'results.survived': 'ТЫ ВЫЖИЛ!',
    'results.finaleSub': '{star} Тьмы больше нет. Ты — вечный Рассвет. {star}',
    'results.winSub': 'Свет одолел тьму. Стал рассветом.',
    'results.demoTitle': 'ДЕМО ПРОЙДЕНА',
    'results.demoSub': 'Полная версия: Глубины Тьмы · вторые фазы боссов · новые герои, оружие и Пути',
    'results.time': 'Прожито',
    'results.level': 'Уровень',
    'results.kills': 'Убито',
    'results.bosses': 'Боссов',
    'results.score': 'Очки',
    'results.gold': 'Золото',
    'results.relics': 'РЕЛИКВИИ',
    'results.unlocked': '{spark} ОТКРЫТО: {names}',
    'results.restart': '{play}  ПРОБЕЛ / КЛИК  —  ЕЩЁ ЗАБЕГ',
    'results.menu': 'M  /  клик  —  меню и магазин',

    // Говорящая фигура (тайник/источник)
    'speak.continue': 'клик / пробел — дальше',

    // Тиры редкости карт
    'rarity.rare': 'РЕДКОЕ',
    'rarity.legend': 'ЛЕГЕНДА',

    // единицы дельты карт («16 урона», «−18% к скорости врагов») — подпись к числу
    'unit.dmg': 'урона',
    'unit.speed': 'скорости',
    'unit.enemySlow': 'к скорости врагов',
    'unit.regen': 'HP/сек',
    'unit.radius': 'радиуса подбора',
    'unit.hp': 'макс. HP',
    'unit.crit': 'шанс крита',
    'unit.cooldown': 'кулдаун',
    'unit.leech': 'HP за убийство',
  },

  // RU данные берутся из config.ts (источник правды) — словарь не нужен.
  data: {},

  // ЛОР «Пепелище» (§14) — фрагменты-голос. Эталонный пул; RU — источник правды.
  // Принцип айсберга: называет образ/состояние, НЕ объясняет историю (§13.4).
  lore: {
    // имена забегов (§14.2) — микро-нарратив на экране итогов
    runNames: [
      'Последний Жар', 'Пепел Третьего', 'Угол, Который Помнит', 'До Первого Слоя',
      'Чужое Горение', 'Ровное Место', 'Прежде Чем Стать Полосой', 'Глубже Холода',
      'Где Форма Заканчивается', 'Теплее, Чем Вчера', 'Отпечаток', 'Нулевой Слой',
    ],
    // голос экрана смерти (§14.1) — рандом из пула, загадка от повторного чтения
    death: [
      'Тепло уходит быстрее, чем ты думал.',
      'Ты стал острее. Потом — ровнее. Потом — ничем.',
      'Края сначала.',
      'Пепел не помнит, чем был.',
      'Форма держалась дольше, чем следовало.',
      'Где-то здесь ты стал похож на всё остальное.',
      'Последнее, что уходит — это имя.',
      'Остыть — значит согласиться.',
      'Ты был теплее, чем они. Этого не хватило.',
      'Геометрия сомкнулась.',
      'Кто-то горел здесь раньше тебя. Тоже далеко зашёл.',
      'Не погас. Просто перестал отличаться.',
    ],
    // голос святилищ (§14.3)
    shrineRelic: [
      'Кто-то держал это в руках, пока ещё было тепло.',
      'Форма чужая. Но греет.',
      'Здесь горели иначе. Это осталось.',
    ],
    shrineCache: [
      'Сложено аккуратно. Будто кто-то собирался вернуться.',
      'Пепел вокруг. Здесь — нет.',
      'Не брошено. Спрятано.',
    ],
    shrineFont: [
      'Откуда идёт тепло — непонятно. Просто идёт.',
      'Здесь форма удерживается сама.',
      'Глубже — теплее. Это должно было успокоить.',
    ],
    // голос победы (§14.4) — амбивалентность побег/ловушка
    victory: [
      'Ты вышел. Или тебя выпустили.',
      'Глубже этого ты ещё не горел.',
      'Ты не остыл. Этого хватило.',
    ],
    // между-забеговые фрагменты на меню (§14.4) — по итогу последнего забега
    menuEarly: [
      'Ещё не дошёл до места, где форма начинает меняться.',
      'Искра. Пока только искра.',
    ],
    menuDeep: [
      'Глубже этого ты пока не был. Здесь другой пепел.',
    ],
    menuStreak: [
      'Столько раз остывал. И снова горишь.',
      'Третий раз подряд так далеко. Кто-то это видит.',
    ],
    menuReturn: [
      'Ты снова здесь. Пепелище не удивлено.',
    ],
    menuDefault: [
      'Либо это сила. Либо ты просто не замечаешь разницы.',
      'Снова тёплый. Это уже что-то.',
    ],
  },
};
